import ErrorPage from 'components/base/ErrorPage';

const SystemError = () => {
  return <ErrorPage title="500" details="The server encountered an error and could not complete your request" />;
};

export default SystemError;
